<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center">
                <h1 class="display-1 font-weight-bold mb-6">Términos y Condiciones</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8" offset-md="2">
                <v-card class="pa-6">
                    <h2 class="title font-weight-bold mb-4">1. Aceptación de los Términos</h2>
                    <p>
                        Al utilizar nuestros servicios, usted acepta cumplir con estos términos y condiciones.
                    </p>

                    <h2 class="title font-weight-bold mb-4">2. Uso del Servicio</h2>
                    <p>
                        Usted acepta utilizar nuestros servicios de manera legal y ética, sin violar derechos de
                        terceros.
                    </p>

                    <h2 class="title font-weight-bold mb-4">3. Propiedad Intelectual</h2>
                    <p>
                        Todo el contenido y software proporcionado por Tech Solutions están protegidos por derechos de
                        autor.
                    </p>

                    <h2 class="title font-weight-bold mb-4">4. Limitación de Responsabilidad</h2>
                    <p>
                        Tech Solutions no será responsable por daños indirectos o consecuentes derivados del uso de
                        nuestros servicios.
                    </p>

                    <h2 class="title font-weight-bold mb-4">5. Modificaciones</h2>
                    <p>
                        Nos reservamos el derecho de modificar estos términos en cualquier momento. Le notificaremos de
                        cambios significativos.
                    </p>

                    <h2 class="title font-weight-bold mb-4">6. Contacto</h2>
                    <p>
                        Para preguntas sobre estos términos, contáctenos en <a
                            href="mailto:terminos@techsolutions.com">terminos@techsolutions.com</a>.
                    </p>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'TermsAndConditions',
};
</script>

<style scoped>
/* Estilos personalizados si es necesario */
</style>